
<template>
  <v-layout>
    <div v-if="accountClaimStatus == 1 && myAccounts.Items[0].contract_status.S != 'online'" class="text-xs-left">
      <span class="title"> We have made you an account on the blockchain</span> <br/><br/><span class="title"><span style="color:gray">Account name:</span> {{myAccounts.Items[0].account_name.S}}</span>
      <br/><br/>
      <p>1. Create new keys in your scatter application to claim your account or press create key below<a  href='https://medium.com/@lachlangreenbank/claiming-smartpress-accounts-7002c95528d8' target="_blank"> help</a></p>
      <v-btn small @click="keyCreate()">Create keys</v-btn><br/>
      <p style="margin-top:20px;">2. Enter your Active key (public key)<a href='https://medium.com/@lachlangreenbank/claiming-smartpress-accounts-7002c95528d8' target="_blank"> help</a></p>

      <a href='https://medium.com/@lachlangreenbank/claiming-smartpress-accounts-7002c95528d8' target="_blank"><v-btn>Account claim guide</v-btn></a>
      

      <v-dialog
        v-model="showFreshKeys"
        hide-overlay
        width="485"
        persistent
      >
        <keyPopup v-if="showFreshKeys" :keys="freshKeys"></keyPopup>
        <v-btn @click="showFreshKeys = false">Close</v-btn>
      </v-dialog>

      <v-text-field v-model="userActiveKey" placeholder="EOS5ytq8eaHgSKLsvKqS2afTQVd3MhtjN8C2aXsgXXG1z1vXGQmRv">  </v-text-field>
      <v-btn style="float:left" @click="keyChange()">Claim account</v-btn>
      
    </div>
    <div style="margin:20px;" v-else>
      <span class="title">Account claimed</span><br/><br/>
      <v-btn href="https://calendly.com/smartpress/integration-session" color="green" target="_blank" dark class="title" large style="position:relative; right:10px;" @click="closeDialog">Book app intergration session</v-btn>
    </div>
  </v-layout>
</template>

<script>
  import store from "@/store"
  import { mapState } from 'vuex'

  import keyPopup from './keyPopup'

  export default {
    data () {
      return {
        userActiveKey: '',
        showFreshKeys: false,
        accountClaimStatus: 1
      }
    },
    components: {
        keyPopup
    },
    computed: {
        ...mapState({
            user: state => state.auth.user,
            userStatus: state => state.contractsDb.userStatus,
            freshKeys: state => state.eosJsFunc.freshKeys,
            logMessage: state => state.util.logMessage,
            myAccounts: state => state.contractsDb.myAccounts,
        })
    },
    props: {
      dialog: Boolean,
    },
    watch: {
    },
    created: function () {
        

    },
    methods: {
        keyChange: async function () {
          let log = await this.$store.dispatch('eosJsFunc/keyChange', {activeKey: this.userActiveKey, accountName: this.myAccounts.Items[0].account_name.S})
          let self = this
          setTimeout(function () {
            console.log(self.logMessage)
            self.accountClaimStatus = self.logMessage.code

            if (self.accountClaimStatus == 0) {
              self.$store.dispatch('contractsDb/accountClaimed', {type: 'user', activeKey: self.userActiveKey, accountName: self.myAccounts.Items[0].account_name.S})
             }
          }, 3000)
        },
        keyCreate: function () {
            this.$store.dispatch('eosJsFunc/keyCreate')

            setTimeout(() => {
                this.showFreshKeys = true
            }, 1000)
        }
    }
  }
</script>

<style>
  .test {
    color:red;
  }
</style>
